import type { FC } from 'react'

import { Input, Label, Select } from '@skytech/ui'
import {
  COUNTRY_FLAGS,
  countryOptions,
  getFormattedPhoneNumber,
  MAX_PHONE_NUMBER_LENGTH,
} from '@skytech/utils'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import Text from '@/app/translations/Text'
import type { OnboardingFormFields } from '@/forms/onboarding/types'

import CurrentOwner from './CurrentOwner'

const SubscriptionInformation: FC<{ values: OnboardingFormFields; isEditable: boolean }> = ({
  values,
  isEditable,
}) => {
  if (values.isNewNumber !== false || values.isOptOutSubscription) return null

  return (
    <section className="subscription-information">
      <h3>
        <Text id="Abonnementsinformasjon" />
      </h3>

      <Label>
        {values.isPrivateNumber ? (
          <Text id="Add the number you want to use" />
        ) : (
          <Text id="Which number do you want transferred?" />
        )}
      </Label>

      <div className="flex items-start justify-between gap-1">
        <Field name="phoneNumberCountryId">
          {({ field, form }: FieldProps) => (
            <Select
              noBorder
              className="mt-[7px] min-w-fit text-2xl"
              id="phoneNumberCountryId"
              options={countryOptions.map(option => ({
                value: option.value,
                label: `${COUNTRY_FLAGS[option.label]} +${option.value}`,
              }))}
              isDisabled={!isEditable}
              {...field}
              onChange={option => {
                form.setFieldValue(field.name, option?.value)

                if (form.values.phoneNo) {
                  const formattedNumber = getFormattedPhoneNumber({
                    value: form.values.phoneNo,
                    countryId: Number(option?.value),
                  })
                  if (formattedNumber !== form.values.phoneNo) {
                    form.setFieldValue('phoneNo', formattedNumber)
                  }
                }
              }}
            />
          )}
        </Field>

        <Field name="phoneNo">
          {({ field, meta, form }: FieldProps) => (
            <Input
              id="phoneNo"
              error={meta.error}
              touched={meta.touched}
              isDisabled={!isEditable}
              maxLength={MAX_PHONE_NUMBER_LENGTH}
              {...field}
              onChange={e => {
                const formattedNumber = getFormattedPhoneNumber({
                  value: e.target.value,
                  countryId: Number(form.values.phoneNumberCountryId),
                })
                form.setFieldValue(field.name, formattedNumber)
              }}
            />
          )}
        </Field>
      </div>

      {!values.isPrivateNumber && <CurrentOwner values={values} />}
    </section>
  )
}

export default SubscriptionInformation
